'use client';

import { ErrorLayout } from '@/components/layout/ErrorLayout';
import { flex } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import type { NextPage } from 'next/types';
import Link from 'next/link';

const Page: NextPage = () => (
  <ErrorLayout
    errorCode="500"
    title="An error has occurred."
    description="Sorry, we encountered an unexpected error."
  >
    <div
      className={flex({
        gap: '2',
      })}
    >
      <Button as={Link} href="/" variant="secondary">
        Go back home
      </Button>
      <Button onClick={() => window.location.reload()}>Reload page</Button>
    </div>
  </ErrorLayout>
);

export default Page;
